export default __webpack_public_path__ + "static/media/comfort1.82eb86db.jpg";